import toast from "react-hot-toast";

const notify = (message, type) => {
  switch (type) {
    case "success":
      toast.success(message);
      break;
    case "error":
      toast.error(message);
    default:
      break;
  }
};

export default notify;
